import React from 'react';

export default function LanguageEdit() {
  // const { id } = useParams();
  // const [loading, setLoading] = useState(false);
  // const [fetched, setFetched] = useState(false);
  // const [reloading, setReloading] = useState(false);
  // const [processing, setProcessing] = useState(false);
  // const [navigateTo, setNavigateTo] = useState<string | null>(null);
  // const [obj, setObj] = useState<Language>(api.working_on_sb === null ? new Language() : new Language({ source_books: [{ id: api.working_on_sb._id, type: api.working_on_sb.source_book_type, third_party: api.working_on_sb.third_party }] }));
  // const [change_time, setChangeTime] = useState(0);
  
  // const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  // useEffect(() => {
  //   if (!fetched) {
  //     load();
  //   }
  // });
    
  // useEffect(() => {
  //   if (reloading) {
  //     setReloading(false);
  //   }
  // }, [reloading, setReloading]);

  // const load = () => {
  //   setFetched(true);
  //   if (id && id !== "") {
  //     setLoading(true);
  //     const onComplete = (res: PlayerObject[] | ModelBase[]) => {
  //       if (res.length === 1 && res[0] instanceof Language) {
  //         setObj(res[0].clone());
  //         setChangeTime(common_util.get_time_number());
  //       }
  //       setLoading(false);
  //     };
  //     const onProgress = () => {};
  //     api.getObjectsWithCallbacks({ 
  //       data_type: "language", filter: { _id: id },
  //       onComplete, onProgress 
  //     });
  //   }
  // }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("language", obj).then(res => {
  //       setProcessing(false);
  //       setNavigateTo("/language");
  //     });
  //   }
  // }

  // const height = window.innerHeight - 120;
  // if (!fetched || loading) {
  //   return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  // } else if (navigateTo !== null) {
  //   return <Navigate to={navigateTo} />;
  // } else { 
  //   return (
  //     <Grid container spacing={0} direction="row">
  //       <Grid item xs={12}>
  //         <div style={{ height, overflowY: "scroll" }}>
  //           <Grid container spacing={0} direction="row">
  //             <Grid item xs={12}>
  //               <ModelBaseInput 
  //                 obj={obj}
  //                 disabled={disabled}
  //                 change_time={change_time}
  //                 onChange={(changed: ModelBase) => {
  //                   if (changed instanceof Language) {
  //                     const new_obj = obj;
  //                     new_obj.copy(changed);
  //                     setObj(new_obj);
  //                     setChangeTime(common_util.get_time_number());
  //                   }
  //                 }}
  //               />
  //             </Grid>
  //             <Grid item xs={12}>
  //               <SelectStringBox
  //                 name="Type"
  //                 options={["Common","Exotic","Specific"]}
  //                 value={obj.type}
  //                 disabled={disabled}
  //                 onChange={(changed: "Common" | "Exotic" | "Specific") => {
  //                   const new_obj = obj;
  //                   new_obj.type = changed;
  //                   setObj(new_obj);
  //                   setChangeTime(common_util.get_time_number());
  //                 }}
  //               />
  //             </Grid>
  //           </Grid>
  //         </div>
  //       </Grid>
  //       { !disabled &&
  //         <Grid item xs={12}>
  //           <Button
  //             variant="contained"
  //             color="primary"
  //             disabled={processing}
  //             onClick={submit}>
  //             Submit
  //           </Button>
  //           <Button
  //             variant="contained"
  //             disabled={processing}
  //             style={{ marginLeft: "4px" }}
  //             onClick={ () => { 
  //               setNavigateTo(`/language`);
  //             }}>
  //             Cancel
  //           </Button>
  //         </Grid>
  //       }
  //     </Grid>
  //   ); 
  // }
  return <></>
}